ClubCourtsPaymentController.$inject = [
    '$scope',
    'CONST',
    '$uibModalInstance',
    'Time',
    '_',
    'court',
    'alerts',
    'User',
];

/* @ngInject */
function ClubCourtsPaymentController(
    $scope,
    CONST,
    $uibModalInstance,
    Time,
    _,
    court,
    alerts,
    User,
) {
    var vm = this;
    vm.title = 'ClubCourtsPaymentController';
    vm.courtName = court.name;

    vm.court = court;
    vm.loading = false;
    vm.options = [
        {
            id: 'flat',
            name: 'Precio Fijo',
        },
        {
            id: 'percent',
            name: 'Porcentaje de turno',
        },
    ];
    
    const MIN_PRICE_ACCEPTED = 20; // same as CourtService.php default
    
    vm.selected = vm.options.find((opt) => opt.id === vm.court.advance_type);

    if (vm.court.advance_type === 'percent' && vm.court.advance <= 1) {
        vm.court.advance = vm.court.advance * 100;
    }

    vm.save = function () {
        if (vm.court.advance_type === 'flat' && vm.court.advance < MIN_PRICE_ACCEPTED) {
            alerts.error(
                '¡Error!',
                `El monto de seña de precio fijo no puede ser menor a ${MIN_PRICE_ACCEPTED}.`,
            );
            return;
        }
        alerts.code(null, null, User).then(save);
    };
    vm.close = function () {
        $uibModalInstance.dismiss();
    };

    ////////////////

    vm.changeTypeAdvance = (opt) => {
        vm.court.advance_type = opt.id;
        vm.court.advance = '';
    };

    function save(code) {
        var data = {
            capture: Boolean(vm.court.capture),
            advance:
                vm.court.advance_type === 'percent'
                    ? parseFloat(vm.court.advance) / 100
                    : parseFloat(vm.court.advance),
            code: code,
            advance_type: vm.court.advance_type,
        };

        vm.loading = true;
        return court.api
            .customPUT(data, '')
            .then(function () {
                court.capture = data.capture;
                court.advance = data.advance;
                court.price_modifiers = data.price_modifiers;
                court.advance_type = data.advance_type;

                $uibModalInstance.dismiss();
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading = false;
            });
    }
}

export default ClubCourtsPaymentController;
